import { IComponentsConfig } from '../../_Common/Components/BusinessCollectionComponents/businessCollectionComponents';
import { initConst } from '../../../../Utils/utils';

export const TIVyer = initConst<IComponentsConfig>(() => ({}));
